import React from 'react';
import { useStateContext } from '../../context/StateContext';
import style from './header.module.scss';
import logoSvg from '../../assets/svg/elogo-logo.svg';

const Header = () => {
	const { state: { pageSettings } } = useStateContext();
	
	return (
		<div className={style.container}>
			<div className={style.content}>
				<img src={pageSettings?.contractorSettings?.logo ? pageSettings?.contractorSettings?.logo : logoSvg}/>
				<span className={style.username} />
			</div>
		</div>
	);
};

export default Header;
